export const TEST_COMPLETED = 3 // when the test have all result types recorded (confirm with the client)
